import { render, staticRenderFns } from "./modal-setting-partner.vue?vue&type=template&id=650d6dba&scoped=true"
import script from "./modal-setting-partner.vue?vue&type=script&lang=js"
export * from "./modal-setting-partner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650d6dba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('650d6dba')) {
      api.createRecord('650d6dba', component.options)
    } else {
      api.reload('650d6dba', component.options)
    }
    module.hot.accept("./modal-setting-partner.vue?vue&type=template&id=650d6dba&scoped=true", function () {
      api.rerender('650d6dba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Campaign/TabTool/modal-setting-partner.vue"
export default component.exports